import type { Uuid } from '@/data/db/primitives';

/**
 * 所有跨表關聯都用 UUID；畫面流水號永遠不得作為關聯鍵（data-model 2.1）。
 * crypto.randomUUID 在 Chrome、Edge、Firefox 的 secure context 都可用，
 * 開發時的 http://localhost 也算 secure context。
 */
export function newUuid(): Uuid {
  return crypto.randomUUID();
}
